import { render, staticRenderFns } from "./ExOrgPosition.vue?vue&type=template&id=236a5fa4"
import script from "./ExOrgPosition.vue?vue&type=script&lang=js"
export * from "./ExOrgPosition.vue?vue&type=script&lang=js"
import style0 from "./ExOrgPosition.vue?vue&type=style&index=0&id=236a5fa4&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports